import React from 'react';
import {useTranslation} from "react-i18next";
import AppTable from "../../../../componentsReusable/AppTable";
import AppModalForm from "../../../../componentsReusable/AppModalForm";
import Button from "../../../Button";
import apiPlatform from "../../../../apiPlatform";
import BsxPrinterAuthForm from "../../../BsxPrinterAuth/BsxPrinterAuthForm";
import {CopyToClipboard} from "react-copy-to-clipboard";
import TextWithTooltip from "../../../../componentsReusable/TextWithTooltip";
import {toast} from "react-toastify";
import {setBsxPrinterAuths} from "../../../../reducers/bsxPrinterAuths/actions";
import {useDispatch, useSelector} from "react-redux";
import PropTypes from "prop-types";
import getDefaultBsxPrinterAuthId, {
  updateDefaultBsxPrinterAuthId
} from "../../../../utils/BsxPrinterAuth/getDefaultBsxPrinterAuthId";

const BsxPrinterAuthTable = props => {
  const { t } = useTranslation('bsx_printer_auth_table')
  const dispatch = useDispatch()
  const tableRef = React.useRef()
  const bsxPrinterAuths = useSelector(state => state.bsxPrinterAuths)
  const [defaultBsxPrinterAuthId, setDefaultBsxPrinterAuthId] = React.useState(getDefaultBsxPrinterAuthId())

  const setAsDefault = (id) => {
    updateDefaultBsxPrinterAuthId(id)
    setDefaultBsxPrinterAuthId(id)
  }

  const columns = [
    {
      dataField: 'name',
      text: t('column.name'),
      formatExtraData: () => true,
      formatter: (cell, row) => {
        return <div className="d-flex flex-row flex-nowrap align-items-center justify-content-between">
          <span>{row.name}</span>

          {bsxPrinterAuths?.length > 1 && <div>
            {
              defaultBsxPrinterAuthId
                ? row.id === defaultBsxPrinterAuthId ? <TextWithTooltip tooltip="Domyślna drukarka na tym urządzeniu">
                  <small className="text-secondary cursor-pointer text-success">{t('column.name_is_default')}</small>
                </TextWithTooltip> : <TextWithTooltip tooltip={t('column.name_click_to_choose_as_default_tooltip')}>
                  <small className="text-secondary cursor-pointer hover-display" onClick={() => setAsDefault(row.id)}>{t('column.name_click_to_choose_as_default')}</small>
                </TextWithTooltip>
                : <TextWithTooltip tooltip={t('column.name_click_to_choose_as_default_tooltip')}>
                  <small className="text-secondary cursor-pointer" onClick={() => setAsDefault(row.id)}>{t('column.name_click_to_choose_as_default')}</small>
                </TextWithTooltip>
            }
          </div>}


        </div>
      }
    },
    {
      dataField: 'username',
      text: t('column.username'),
      headerStyle: {
        width: 88
      },
      formatter: (cell, row) => <span className="cursor-pointer"><CopyToClipboard text={row.username} onCopy={() => toast.success(t('username_copied'))}><TextWithTooltip tooltip={t('common:click_to_copy')}><span>{row.username}</span></TextWithTooltip></CopyToClipboard></span>
    },
    {
      dataField: 'password',
      text: t('column.password'),
      headerStyle: {
        width: 235
      },
      formatter: (cell, row) => <span className="cursor-pointer"><CopyToClipboard text={row.password} onCopy={() => toast.success(t('password_copied'))}><TextWithTooltip tooltip={t('common:click_to_copy')}><span>{row.password}</span></TextWithTooltip></CopyToClipboard></span>
    },
  ];

  return (
    <AppTable
      tableWrapper={false}
      ref={tableRef}
      tableSize={'sm'}
      pagination={false}
      searchable={false}
      rowClasses="hoverable"
      addButton={props.addButton && <AppModalForm
        size="md"
        modalOpen={props.addModalOpen}
        modalTitle={t('create_modal.title')}
        formProps={{
          apiFn: apiPlatform.bsxPrinterAuths,
          onCreated: () => tableRef.current.fetchData(),
        }}
        form={BsxPrinterAuthForm}
      ><Button size="sm"><i className="fas fa-plus" /><span>{t('common:btn.create')}</span></Button></AppModalForm>}
      columns={columns}
      apiFnList={apiPlatform.bsxPrinterAuths.list}
      apiFnDelete={apiPlatform.bsxPrinterAuths.delete}
      onDataFetched={data => {
        dispatch(setBsxPrinterAuths(data))
      }}
      onRemoved={props.removeButton ? () => {
        tableRef.current.fetchData()
      } : null}
    />
  );
};

BsxPrinterAuthTable.defaultProps = {
  addModalOpen: false,
  addButton: true,
  removeButton: true,
};

BsxPrinterAuthTable.propTypes = {
  addModalOpen: PropTypes.bool,
  addButton: PropTypes.bool,
  removeButton: PropTypes.bool,
};

export default BsxPrinterAuthTable;